/*
 * Version: 1.6.0 - 2026-08-05 18:25 (UTC+8) - Plaud Tayler — D1 merge: ARIA-tab core moved to shared ww-tabs.js;
 *   this file keeps only the video engine (cross-fade / preload / auto-tour / replay), attached via the
 *   root's ww:tabchange event; programmatic switching (auto-tour) goes through window.wwTabs.activate
 * Version-note: 1.5.0 - 2026-08-03 14:40 — DTC-953 auto-tour replaces the scrolling pin
 * WW Sigma Wearable — vertical tab switcher + per-tab background video (play once)
 * Author: Tayler — 2026-06-30
 * ARIA-tab pattern (document-delegated, survives Section Rendering API hot-reload). Each tab
 * maps to a full-bleed background video that plays ONCE then pauses; a bottom-right replay
 * control fades in when the active clip ends and replays it on click. Switching a tab restarts
 * the new active clip. The active clip only plays while the section is on screen. Binds once.
 */
(function () {
  if (window.__wwSigmaWearableTabs) return;
  window.__wwSigmaWearableTabs = true;

  function activeVideo(root) { var w = root.querySelector('[data-bg-index].is-active'); return w ? w.querySelector('video') : null; }
  function showReplay(root, on) { var b = root.querySelector('[data-wearable-replay]'); if (b) b.classList.toggle('is-visible', on); }
  function playOnce(v) { if (!v) return; try { v.currentTime = 0; } catch (e) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  // network gate: on Save-Data or 2g-class connections skip ALL warming — posters carry the
  // visuals and clips stream on demand (2026-07-28 perf audit P0-1) - Plaud Tayler
  function frugalNetwork() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g/.test(c.effectiveType || '')));
  }

  // kick a video's download without touching playing clips (load() would restart them)
  function warm(v) {
    if (!v || v.readyState >= 2 || frugalNetwork()) return;
    var w = v.closest('[data-bg-index]');
    if (w && w.classList.contains('is-active') && !v.paused) return;
    v.preload = 'auto';
    try { v.load(); } catch (e) {}
  }

  /* video part (the latter half of the old activate): tab tri-state and panels are handled by the
     ww-tabs.js engine; this function is invoked via the ww:tabchange event - Plaud Tayler - 2026-08-05 18:25 */
  function videoSync(root, i) {
    // cross-fade the background video: restart + play the active (once), pause the rest
    var vids = root.querySelectorAll('[data-bg-index]');
    Array.prototype.forEach.call(vids, function (w, j) {
      var on = j === i;
      w.classList.toggle('is-active', on);
      var v = w.querySelector('video');
      if (!v) return;
      if (on) { playOnce(v); } else { v.pause(); }
    });
    // look-ahead: make sure the NEXT tab's clip is downloading (fast scrubbing through the
    // pin can outrun the sequential preloader) - Plaud Tayler - 2026-07-27
    if (vids[i + 1]) warm(vids[i + 1].querySelector('video'));
    showReplay(root, false); // the new active clip is playing → hide replay
  }

  // sequential preload - once the section nears the viewport, pull the clips one at a time in tab
  // order (parallel fetches would starve the clip currently playing). canplaythrough or a
  // 5s timeout advances the queue so one slow clip can't stall the rest. - Plaud Tayler - 2026-07-27
  // DESKTOP ONLY since 2026-07-28 (perf audit P0-1): the 6 mobile clips total ~58MB — on
  // ≤1024 we rely on posters + the activate() look-ahead (N+1) instead of a full pull.
  function preloadSequentially(sec) {
    if (sec.__preloadStarted) return;
    sec.__preloadStarted = true;
    if (mobileMq.matches || frugalNetwork()) return;
    var vids = Array.prototype.slice.call(sec.querySelectorAll('[data-bg-index] video'));
    var i = 0;
    function next() {
      if (i >= vids.length) return;
      var v = vids[i++];
      if (v.readyState >= 3) return next();
      var w = v.closest('[data-bg-index]');
      if (w && w.classList.contains('is-active') && !v.paused) return next(); // playing — already streaming
      var done = false;
      var t = setTimeout(finish, 5000);
      function finish() {
        if (done) return;
        done = true;
        clearTimeout(t);
        v.removeEventListener('canplaythrough', finish);
        next();
      }
      v.addEventListener('canplaythrough', finish);
      v.preload = 'auto';
      try { v.load(); } catch (e) { finish(); }
    }
    next();
  }

  document.addEventListener('click', function (e) {
    // replay control → restart the active clip (user takes over — auto tour stops)
    var rb = e.target.closest && e.target.closest('[data-wearable-replay]');
    if (!rb) return;
    var rRoot = rb.closest('.ww-sigma-wearable');
    if (rRoot) { rRoot.__tourStop = true; playOnce(activeVideo(rRoot)); showReplay(rRoot, false); }
  });

  /* tab switching is driven by the ww-tabs.js engine; only the video sync hooks in here.
     source=user (click/keyboard) = user takes over, the tour stops; source=api (auto-tour
     programmatic switch) does not stop it - Plaud Tayler - 2026-08-05 18:25 */
  document.addEventListener('ww:tabchange', function (e) {
    var root = e.target;
    if (!root.classList || !root.classList.contains('ww-sigma-wearable')) return;
    if (e.detail && e.detail.source === 'user') root.__tourStop = true;
    videoSync(root, e.detail.index);
  });

  // mobile video source - pick the mobile clip (data-mobile-src) at ≤1024, the desktop one above;
  // re-applied when the breakpoint is crossed (src swap + load + replay the active clip)
  // mobile redefined as <768 (was ≤1024): 768-1024 uses the desktop layout + landscape clip - Plaud Tayler - 2026-07-30
  var mobileMq = window.matchMedia('(max-width: 768px)');
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)'); // gates the auto tour - 2026-08-03
  function applySources(sec) {
    Array.prototype.forEach.call(sec.querySelectorAll('[data-bg-index] video[data-mobile-src]'), function (v) {
      var want = mobileMq.matches ? v.getAttribute('data-mobile-src') : v.getAttribute('data-desktop-src');
      var srcEl = v.querySelector('source');
      if (!srcEl || srcEl.getAttribute('src') === want) return;
      srcEl.setAttribute('src', want);
      v.load();
      var w = v.closest('[data-bg-index]');
      if (w && w.classList.contains('is-active')) playOnce(v);
    });
  }
  if (mobileMq.addEventListener) mobileMq.addEventListener('change', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.ww-sigma-wearable'), applySources);
  });

  // background video: play the active clip once while on screen; pause off-view; replay when it ends
  function initBg(root) {
    var secs = (root || document).querySelectorAll('.ww-sigma-wearable');
    Array.prototype.forEach.call(secs, function (sec) {
      if (sec.__bgInit || !sec.querySelector('[data-bg-index]')) return;
      sec.__bgInit = true;
      applySources(sec);

      // auto tour (DTC-953, replaces the removed scrolling pin): when the current clip ends,
      // automatically switch to the next tab; after one full round, stop on the last tab and show
      // replay. A manual tab click / arrow key / replay means the user takes over (tour stops).
      // No auto-switching under prefers-reduced-motion (WCAG 2.2.2; the IO off-screen pause
      // already freezes the tour anyway).
      // - Plaud Tayler - 2026-08-03 14:40 - Begin
      Array.prototype.forEach.call(sec.querySelectorAll('[data-bg-index] video'), function (v) {
        v.addEventListener('ended', function () {
          var w = v.closest('[data-bg-index]');
          if (!w || !w.classList.contains('is-active')) return;
          if (!sec.__tourStop && !reduceMq.matches) {
            var wraps = Array.prototype.slice.call(sec.querySelectorAll('[data-bg-index]'));
            var i = wraps.indexOf(w);
            if (i > -1 && i < wraps.length - 1) { if (window.wwTabs) { window.wwTabs.activate(sec, i + 1); } else { videoSync(sec, i + 1); } return; }
            sec.__tourStop = true; // full round done, stop on the last tab
          }
          // hold the final frame as-is (full opacity — nothing dims it in CSS); surface replay
          showReplay(sec, true);
        });
      });
      // auto tour - End

      if (typeof IntersectionObserver === 'undefined') { playOnce(activeVideo(sec)); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            preloadSequentially(sec); // warm the remaining clips before the pin reaches them
            var active = activeVideo(sec);
            if (active && !active.ended) { var p = active.play(); if (p && p.catch) p.catch(function () {}); }
          } else {
            Array.prototype.forEach.call(sec.querySelectorAll('[data-bg-index] video'), function (v) { v.pause(); });
          }
        });
      }, { threshold: 0.15 });
      io.observe(sec);
    });
  }

  if (document.readyState !== 'loading') initBg(document);
  else document.addEventListener('DOMContentLoaded', function () { initBg(document); });
  document.addEventListener('shopify:section:load', function (e) { initBg(e.target); });
})();
